<ds-panel class="p-mt-4">
  <ds-table
    [sterownik]="sterownik"
    [model]="tableData"
    [loading]="loading"
    [columnTemplates]="{registrationDate: TimeTemplate, actions: actionsTmpl}">
  </ds-table>
  <ds-button label="Pokaż wszystkie powiadomienia PRS" (onClick)="showAllNotificationsPRS()" [styleClass]="'p-mt-2'"></ds-button>
</ds-panel>

<ng-template #TimeTemplate let-element>
  <span [innerText]="element.registrationDate | date: 'yyyy-MM-dd HH:mm:ss'"></span>
</ng-template>

<ng-template #actionsTmpl let-element>
  <div class="row-button-actions action-buttons-position">
    <ds-button
      [styleClass]="'p-mr-1'"
      severity="link"
      icon="pi pi-eye"
      [pTooltip]="'pokazPowiadomienie' | transloco"
      (click)="viewNotification(element)"
    ></ds-button>
    <ds-button
      severity="link"
      icon="pi pi-times"
      [pTooltip]="(element.deleted ? 'usunietePowiadomienie' : 'usunPowiadomienie') | transloco"
      (click)="deleteNotification(element, 'usuniecie')"
      [disabled]="element.deleted"
      ></ds-button>
  </div>
</ng-template>

<ds-modal #modal>
  <div class="notification-date" dsModalDate
      [innerText]="activeNotificationModal?.registrationDate | date: 'yyyy-MM-dd HH:mm:ss'"></div>
  <div dsModalTitle [innerText]="activeNotificationModal?.module"></div>
  <div dsModalContent>
      <div style="line-height: normal" [innerHTML]="activeNotificationModal?.content">Treść powiadomienia</div>
  </div>
</ds-modal>

<ds-confirm-dialog width="350px" [header]="dialogHeader | transloco" [message]="dialogMessage | transloco" (closed)="confirmClosed($event)" [(openDialog)]="dialogOpened"></ds-confirm-dialog>
